module.exports = __webpack_public_path__ + "static/mds-986f6a4c0f1f91d4d08a68f56038bab7.png";